import { CurrencyPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { KENDO_SKELETON } from '@progress/kendo-angular-indicators';
import { KENDO_CARD, KENDO_GRIDLAYOUT } from '@progress/kendo-angular-layout';
import { AgreementStatsDto } from '@unity/clients';
import { CardAgreementSummarySharedComponent } from '@unity/shared/card-agreement-summary-shared/card-agreement-summary-shared.component';

@Component({
  selector: 'unity-card-funds-expensed-summary-shared',
  standalone: true,
  imports: [KENDO_CARD, KENDO_SKELETON, CurrencyPipe, KENDO_GRIDLAYOUT, CardAgreementSummarySharedComponent],
  templateUrl: './card-funds-expensed-summary-shared.component.html',
  styleUrl: './card-funds-expensed-summary-shared.component.scss',
})
export class CardFundsExpensedSummarySharedComponent {
  public readonly $agreement = input.required<AgreementStatsDto | undefined>({ alias: 'agreement' });
  public readonly $isLoading = input.required<boolean>({ alias: 'isLoading' });
}
